import { observer } from 'mobx-react';
import { useParams } from 'react-router';
import { makeStyles } from '@material-ui/core';
import { SingleTaskDetailView } from './components/singleTaskDetailView';
import { Layout } from '@roc/feature-app-core';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: 'transparent !important',
    },
  },
  container: {
    //Same as nportal dashboard
    maxWidth: '1400px',
  },
}));

export const SingleTaskDetailViewInternal = observer(() => {
  const { taskId } = useParams<{ taskId: string }>();
  const classes = useStyles();

  if (!taskId) {
    return null;
  }

  return (
    <Layout title={`Tasks #${taskId}`} containerClass={classes.container}>
      <SingleTaskDetailView taskId={taskId} />
    </Layout>

  );
});
